import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Endpoints } from '../../../api/Constants';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
export var postToggleMarketingEmailsMutation = {
  query: function query(data) {
    return {
      url: Endpoints.ACTION_COMMAND_MARKETING_EMAIL,
      method: 'post',
      body: {
        data: data
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  keepUnusedDataFor: 0,
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, _ref) {
      var queryFulfilled;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              handleQueryLoggerEvents(_context.t0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var postToggleNotificationsMutation = {
  query: function query(data) {
    return {
      url: Endpoints.ACTION_COMMAND_NOTIFICATION,
      method: 'post',
      body: {
        data: data
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  keepUnusedDataFor: 0,
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, _ref2) {
      var queryFulfilled;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              queryFulfilled = _ref2.queryFulfilled;
              _context2.prev = 1;
              _context2.next = 4;
              return queryFulfilled;

            case 4:
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              handleQueryLoggerEvents(_context2.t0);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 6]]);
    }));

    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var postTriggersNotifyMutation = {
  query: function query(_ref3) {
    var executionId = _ref3.executionId,
        payload = _ref3.payload;
    return {
      url: "".concat(Endpoints.ACTION_COMMAND_TRIGGER, "/").concat(executionId),
      body: {
        data: _objectSpread({}, payload && _objectSpread({}, payload))
      },
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  keepUnusedDataFor: 0
};
export var deleteTriggersNotifyMutation = {
  query: function query(_ref4) {
    var executionId = _ref4.executionId;
    return {
      url: "".concat(Endpoints.ACTION_COMMAND_TRIGGER, "/").concat(executionId),
      method: 'del'
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  keepUnusedDataFor: 0
};